import { useState } from 'react'
import PropTypes from 'prop-types'
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import BacCardDesign from '../CreateACard/Landing/BacCardDesignList/BacCardDesign'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '20px',
        backgroundColor: '#F5F5F5',
        position: 'sticky',
        top: 0,
        zIndex: 1,
    },
    closeButton: {
        padding: 0,
    },
    button: {
        borderRadius: 49,
        color: '#3B1A6E',
        backgroundColor: 'white',
        border: '3px solid #005C59',
        height: 52,
        width: 338,
        fontSize: '1.0rem',
        textTransform: 'none',
        fontWeight: 700,
        cursor: 'pointer',
    },
    footer: {
        position: 'sticky',
        bottom: 0,
        backgroundColor: '#fff',
        borderTop: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'center',
        height: 119,
        boxShadow: '0px -6px 12px 0px rgba(0, 0, 0, 0.25)',
    },
    modalDesignsContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '1rem',
        listStyle: 'none',
        padding: 0,
        [theme.breakpoints.up('sm')]: {
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
    },
}))
const DesignSelectionModal = ({
    isOpen,
    onClose,
    itemCollection,
    cloudinaryIdProperty,
    imageUrlProperty,
    designNameProperty,
    selectedItem,
    onItemSelected,
    overlay,
}) => {
    const [tempSelectedItem, setTempSelectedItem] = useState(selectedItem)
    const classes = useStyles()
    const handleDesignSelect = (item) => {
        setTempSelectedItem(item)
    }

    const handleDoneClick = () => {
        if (tempSelectedItem) {
            onItemSelected(tempSelectedItem)
        }
        onClose()
    }

    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="sm">
            <div className={classes.titleContainer}>
                <Typography style={{ fontSize: '20px', fontWeight: 700 }}>
                    Select a design
                </Typography>
                <IconButton onClick={onClose} className={classes.closeButton}>
                    <CloseIcon size="lg" />
                </IconButton>
            </div>
            <DialogContent dividers>
                <ul
                    id="modal-designs-container"
                    className={classes.modalDesignsContainer}
                >
                    {itemCollection.map((item) => (
                        <li key={item.id}>
                            <BacCardDesign
                                item={item}
                                cloudinaryId={item[cloudinaryIdProperty]}
                                imageUrl={item[imageUrlProperty]}
                                imageTitle={`${item[designNameProperty]}`}
                                imageAlt={`${item[designNameProperty]} Gift Design`}
                                selectedItem={tempSelectedItem}
                                onItemSelected={handleDesignSelect}
                                overlay={overlay}
                            />
                        </li>
                    ))}
                </ul>
            </DialogContent>
            <DialogActions className={classes.footer}>
                <Button
                    onClick={handleDoneClick}
                    className={classes.button}
                    color="primary"
                >
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DesignSelectionModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    itemCollection: PropTypes.array.isRequired,
    cloudinaryIdProperty: PropTypes.string.isRequired,
    imageUrlProperty: PropTypes.string.isRequired,
    designNameProperty: PropTypes.string.isRequired,
    selectedItem: PropTypes.object,
    onItemSelected: PropTypes.func.isRequired,
    overlay: PropTypes.element,
}

export default DesignSelectionModal
